module.exports = __webpack_public_path__ + "static/prowritingaid.com-095ba4cd0eeb0914076d493e6dcaefc4.png";